import { Paper } from '@material-ui/core';
import React from 'reactn';
import { globalStyles } from '../../style/GlobalStyles';
import DettagliImpresaFamiliare from './DettagliImpresaFamiliare';
import DettagliSocietaDiPersoneSrlInRegimeDiTrasparenza from './DettagliSocietaDiPersoneSrlInRegimeDiTrasparenza';
import DettagliSrlNonTrasparente from './DettagliSrlNonTrasparente';
import { SchedaBudgetInputProps } from './InformazioniCosti';

export default function Dettagli(props: SchedaBudgetInputProps) {
    const gClasses = globalStyles();
    const action = "";
    const { state } = props;

    const handleChange = (e: any) => {
        let { name, value } = e.target;
        props.handleChange(action, name, value);
    }

    return (
        <>
            {(state.informazioniCostiDiAvvio.tipologia === "IMPRESA_FAMILIARE" ?
            (<DettagliImpresaFamiliare state={state} handleChange={handleChange}></DettagliImpresaFamiliare>) :
            state.informazioniCostiDiAvvio.tipologia === "SOCIETA_DI_PERSONE" || state.informazioniCostiDiAvvio.tipologia === "SRL_TRASPARENTE" ?
                (<DettagliSocietaDiPersoneSrlInRegimeDiTrasparenza state={state} handleChange={handleChange}></DettagliSocietaDiPersoneSrlInRegimeDiTrasparenza>) :
                <DettagliSrlNonTrasparente state={state} handleChange={handleChange}></DettagliSrlNonTrasparente>)}
        </>
    )
}